import React from 'react';

const UnAuthSuccessIcon = (): JSX.Element => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.52 46.72L50.08 24.16L45.6 19.68L27.52 37.76L18.4 28.64L13.92 33.12L27.52 46.72ZM32 64C27.5733 64 23.4133 63.16 19.52 61.48C15.6267 59.8 12.24 57.52 9.36 54.64C6.48 51.76 4.2 48.3733 2.52 44.48C0.84 40.5867 0 36.4267 0 32C0 27.5733 0.84 23.4133 2.52 19.52C4.2 15.6267 6.48 12.24 9.36 9.36C12.24 6.48 15.6267 4.2 19.52 2.52C23.4133 0.84 27.5733 0 32 0C36.4267 0 40.5867 0.84 44.48 2.52C48.3733 4.2 51.76 6.48 54.64 9.36C57.52 12.24 59.8 15.6267 61.48 19.52C63.16 23.4133 64 27.5733 64 32C64 36.4267 63.16 40.5867 61.48 44.48C59.8 48.3733 57.52 51.76 54.64 54.64C51.76 57.52 48.3733 59.8 44.48 61.48C40.5867 63.16 36.4267 64 32 64ZM32 57.6C39.1467 57.6 45.2 55.12 50.16 50.16C55.12 45.2 57.6 39.1467 57.6 32C57.6 24.8533 55.12 18.8 50.16 13.84C45.2 8.88 39.1467 6.4 32 6.4C24.8533 6.4 18.8 8.88 13.84 13.84C8.88 18.8 6.4 24.8533 6.4 32C6.4 39.1467 8.88 45.2 13.84 50.16C18.8 55.12 24.8533 57.6 32 57.6Z"
      fill="#00AA45"
    />
  </svg>
);

export { UnAuthSuccessIcon };
